import React, { useEffect, useState } from "react";
import axios from "axios";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import LoadingSpinner from "../../components/items/LoadingSpinner";
import { mainURL } from "../../assets/constants/api";
const SuccessStory = () => {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const fetchStories = async () => {
      try {
        const response = await axios.get(
          `${mainURL}/web/success-stories/get-stories?page=1`
        );
        if (response.data.success) {
          setStories(response.data.data.stories);
        } else {
          setError("فشل في جلب القصص");
        }
      } catch (err) {
        setError("حدث خطأ أثناء تحميل القصص");
        
      } finally {
        setLoading(false);
      }
    };

    fetchStories();
  }, []);

  return (
    <div className="container my-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
       
        <h3 className="text-danger m-auto">قصص النجاح</h3>
        
      </div>

      {loading && <LoadingSpinner />}
      {error && <div className="alert alert-danger">{error}</div>}

      <div className="row">
        {!loading &&
          !error &&
          stories.map((story) => (
            <div key={story.id} className="col-md-6 col-lg-4 mb-4" >
              <div className="card h-100 shadow-sm bg-transparent" >
                <div className="card-body d-flex flex-column rounded" style={{backgroundColor:"#5A427F"}}>
                  <p className="text-danger mb-2">المدة: {story.success_time}</p>
                  <p className="card-text flex-grow-1">{story.story_content}</p>
                  <span
                    className="badge bg-warning align-self-start"
                    style={{ color: "#391965" }}
                  >
                    <Link to={`/member-profile/${story.user_id}`}>
                      زيارة الملف الشخصي
                    </Link>
                  </span>
                </div>
              </div>
            </div>
          ))}
      </div>

     
    </div>
  );
};

export default SuccessStory;
